import { render } from "./CatalogsTitle.vue?vue&type=template&id=1c61623d&scoped=true&ts=true&lang=pug"
import script from "./CatalogsTitle.vue?vue&type=script&lang=ts"
export * from "./CatalogsTitle.vue?vue&type=script&lang=ts"

import "./CatalogsTitle.vue?vue&type=style&index=0&id=1c61623d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c61623d"]])

export default __exports__